import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { AppDatePipe } from './app-date/app-date.pipe';
import { AppCurrencyPipe } from './app-currency/app-currency.pipe';
import { AppSafePipe } from './app-safe/app-safe.pipe';
import { AppFilterPipe } from './app-filter/app-filter.pipe';
import { AppSelectSearchPipe } from './app-select-search/app-select-search.pipe';
import { EmailMaskPipe } from './email-mask.pipe';
import { TinViewPipe } from './tin-view/tin-view.pipe';
import { VinViewPipe } from './vin-view/vin-view.pipe';
import { EncodeUrlPipe } from './encode-url/encode-url.pipe';

@NgModule({
  declarations: [
    AppDatePipe,
    AppCurrencyPipe,
    AppSafePipe,
    AppFilterPipe,
    AppSelectSearchPipe,
    EmailMaskPipe,
    TinViewPipe,
    VinViewPipe,
    EncodeUrlPipe,
  ],
  imports: [CommonModule],
  providers: [CurrencyPipe],
  exports: [
    AppDatePipe,
    AppCurrencyPipe,
    AppSafePipe,
    AppSelectSearchPipe,
    AppFilterPipe,
    EmailMaskPipe,
    TinViewPipe,
    VinViewPipe,
    EncodeUrlPipe
  ],
})
export class PipesModule { }
